module.exports = __webpack_public_path__ + "media/app-store/slider-arrow-53663e09.svg";